(function () {
  const DURATION = 350; // ms

  function isEl(node) {
    return node && node.nodeType === 1;
  }

  // -----------------------------
  // Collapse (com animação height .35s)
  // -----------------------------
  function getCollapseSelector(btn) {
    return (
      btn.getAttribute('data-bs-target') ||
      btn.getAttribute('data-target') ||
      (btn.getAttribute('aria-controls') ? ('#' + btn.getAttribute('aria-controls')) : '') ||
      btn.getAttribute('href') ||
      ''
    );
  }

  function findCollapseTarget(btn) {
    const sel = getCollapseSelector(btn);
    if (!sel || !sel.startsWith('#')) return null;

    // tenta dentro do bloco da tab primeiro
    const scope = btn.closest('.tab-block, .tab-description, .tab_description, body');
    return (scope && scope.querySelector(sel)) || document.querySelector(sel);
  }

  function setCollapseBtnState(btn, expanded) {
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.classList.toggle('collapsed', !expanded);
  }

  function onTransitionEndOnce(el, cb) {
    let done = false;
    const handler = (e) => {
      if (e.target !== el) return;
      if (done) return;
      done = true;
      el.removeEventListener('transitionend', handler);
      cb();
    };
    el.addEventListener('transitionend', handler);

    // fallback
    window.setTimeout(() => {
      if (!done) {
        done = true;
        el.removeEventListener('transitionend', handler);
        cb();
      }
    }, DURATION + 50);
  }

  function showCollapse(target, btn) {
    if (target.classList.contains('show') || target.classList.contains('collapsing')) return;

    // display block para medir altura
    target.classList.remove('collapse');
    target.classList.add('collapsing');
    target.style.display = 'block';
    target.style.height = '0px';

    // força reflow
    target.offsetHeight;

    const h = target.scrollHeight;
    target.style.height = h + 'px';
    setCollapseBtnState(btn, true);

    onTransitionEndOnce(target, () => {
      target.classList.remove('collapsing');
      target.classList.add('collapse', 'show');
      target.style.height = '';
      target.style.display = '';
    });
  }

  function hideCollapse(target, btn) {
    if (!target.classList.contains('show') || target.classList.contains('collapsing')) return;

    const h = target.scrollHeight;

    target.classList.remove('collapse', 'show');
    target.classList.add('collapsing');
    target.style.display = 'block';
    target.style.height = h + 'px';

    // força reflow
    target.offsetHeight;

    target.style.height = '0px';
    setCollapseBtnState(btn, false);

    onTransitionEndOnce(target, () => {
      target.classList.remove('collapsing');
      target.classList.add('collapse');
      target.style.height = '';
      target.style.display = 'none';
    });
  }

  function toggleCollapse(btn) {
    const target = findCollapseTarget(btn);
    if (!target) return;

    const isOpen = target.classList.contains('show');
    if (isOpen) hideCollapse(target, btn);
    else showCollapse(target, btn);
  }

  function syncCollapses(container) {
    // estado inicial de display baseado em show
    container.querySelectorAll('.collapse').forEach((el) => {
      if (el.classList.contains('show')) el.style.display = 'block';
      else el.style.display = 'none';
    });

    container.querySelectorAll('.btn-collapse').forEach((btn) => {
      const target = findCollapseTarget(btn);
      const expanded = target ? target.classList.contains('show') : false;
      setCollapseBtnState(btn, expanded);
    });
  }

  // -----------------------------
  // Tabs (agora mais robusto: não depende de siblings diretos)
  // -----------------------------
  function getAllTabsRoots(scope) {
    return Array.from(scope.querySelectorAll('.tabs'));
  }

  function nodeFollows(a, b) {
    // b vem depois de a no DOM?
    return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function nodePrecedes(a, b) {
    // a vem antes de b no DOM?
    return !!(a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function collectTabBlocksFor(tabsRoot) {
    // 1) acha um escopo razoável (pai comum que contenha os blocos)
    let scope = tabsRoot.parentElement;
    while (scope && scope !== document.body) {
      if (scope.querySelector('.tab-block, .tab_description, .tab-description')) break;
      scope = scope.parentElement;
    }
    scope = scope || document.body;

    // 2) pega todos blocos dentro do escopo
    let blocks = Array.from(scope.querySelectorAll('.tab-block, .tab_description, .tab-description'));

    // 3) mantém só os blocos que vêm DEPOIS deste tabsRoot
    blocks = blocks.filter((b) => nodeFollows(tabsRoot, b));

    // 4) corta quando existir o próximo .tabs (para não misturar instâncias)
    const tabsRoots = getAllTabsRoots(scope).filter((t) => t !== tabsRoot);
    const nextTabs = tabsRoots.find((t) => nodeFollows(tabsRoot, t)); // primeiro depois
    if (nextTabs) {
      blocks = blocks.filter((b) => nodePrecedes(b, nextTabs)); // b antes do próximo tabs
    }

    return blocks;
  }

  function getBlockByIndex(blocks, index) {
    const idx = String(index);

    // 1) classe block-of-tab-X
    const byClass = blocks.find((b) => b.classList && b.classList.contains('block-of-tab-' + idx));
    if (byClass) return byClass;

    // 2) fallback id com underline e com hífen (você usa item-tabsX)
    const byIdUnderscore = blocks.find((b) => b.id === ('item_tabs' + idx));
    if (byIdUnderscore) return byIdUnderscore;

    const byIdHyphen = blocks.find((b) => b.id === ('item-tabs' + idx));
    return byIdHyphen || null;
  }

  function initTabsComponent(tabsRoot) {
    const buttons = Array.from(tabsRoot.querySelectorAll('.tab-item[data-tab]'));
    if (!buttons.length) return;

    const blocks = collectTabBlocksFor(tabsRoot);
    if (!blocks.length) return;

    function deactivateAll() {
      buttons.forEach((b) => b.classList.remove('active'));
      blocks.forEach((blk) => {
        blk.classList.remove('active');
        blk.style.display = 'none';
      });
    }

    function activate(index) {
      const idx = String(index);
      const btn = buttons.find((b) => String(b.dataset.tab) === idx);
      const blk = getBlockByIndex(blocks, idx);
      if (!btn || !blk) return;

      deactivateAll();
      btn.classList.add('active');
      blk.classList.add('active');
      blk.style.display = 'block';

      // ressincroniza collapses dentro do bloco aberto
      syncCollapses(blk);
    }

    tabsRoot.addEventListener('click', (ev) => {
      const btn = ev.target.closest('.tab-item[data-tab]');
      if (!btn || !tabsRoot.contains(btn)) return;
      ev.preventDefault();
      activate(btn.dataset.tab);
    });

    const initial = buttons.find((b) => b.classList.contains('active')) || buttons[0];
    activate(initial.dataset.tab);
  }

  // -----------------------------
  // Boot
  // -----------------------------
  function boot() {
    document.querySelectorAll('.tabs').forEach(initTabsComponent);

    // Clique do collapse (delegado)
    document.addEventListener('click', (ev) => {
      const btn = ev.target.closest('.btn-collapse');
      if (!btn) return;
      ev.preventDefault();
      toggleCollapse(btn);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
